module.exports = __webpack_public_path__ + "static/img/icono_escuchar.6fa31dc4.svg";